export default "__VITE_ASSET__7d476f56__"